import { render, staticRenderFns } from "./OAuthCallback.vue?vue&type=template&id=d8791284&scoped=true"
import script from "./OAuthCallback.vue?vue&type=script&lang=js"
export * from "./OAuthCallback.vue?vue&type=script&lang=js"
import style0 from "./OAuthCallback.vue?vue&type=style&index=0&id=d8791284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8791284",
  null
  
)

export default component.exports